<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <h1 class="d-flex align-center">
          <v-btn
            id="btn-voltar"
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'franquias' })"
            :disabled="criandoFranquia"
            class="mr-2"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Franquia
        </h1>
      </v-col>
    </v-row>

    <form @submit.prevent="submitForm" :disabled="criandoFranquia">
      <v-row>
        <v-col cols="12" md="8" class="pt-0 pb-0">
          <ValidationProvider name="Nome da unidade" rules="required" v-slot="{ errors }">
            <e-label>Nome da Unidade</e-label>
            <v-text-field
              id="input-nome-unidade"
              :error-messages="errors"
              v-model="form.descricao"
              solo
              dense
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="4" class="pt-0 pb-0">
          <ValidationProvider name="INEP" rules="required" v-slot="{ errors }">
            <e-label>INEP</e-label>
            <v-text-field
              id="input-inep"
              v-model="form.inep"
              :error-messages="errors"
              solo
              dense
              v-mask="'########'"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <h2 class="text-h6">Endereço</h2>
        </v-col>
        <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
          <e-label>CEP</e-label>
          <v-text-field id="input-cep" v-mask="'#####-###'" v-model="form.cep" solo dense />
        </v-col>
        <v-col cols="12" sm="6" md="8" class="pt-0 pb-0">
          <ValidationProvider name="Cidade" rules="required" v-slot="{ errors }">
            <e-label>Cidade</e-label>
            <v-text-field
              id="input-cidade"
              v-model="form.cidade"
              :error-messages="errors"
              solo
              dense
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
          <ValidationProvider name="Estado" rules="required" v-slot="{ errors }">
            <e-label>Estado</e-label>
            <v-text-field
              id="input-estado"
              v-model="form.estado"
              :error-messages="errors"
              solo
              dense
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" class="pt-0 pb-0">
          <ValidationProvider name="Bairro" rules="required" v-slot="{ errors }">
            <e-label>Bairro</e-label>
            <v-text-field
              id="input-bairro"
              v-model="form.bairro"
              :error-messages="errors"
              solo
              dense
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" class="pt-0 pb-0">
          <ValidationProvider name="Logradouro" rules="required" v-slot="{ errors }">
            <e-label>Logradouro</e-label>
            <v-text-field
              id="input-logradouro"
              v-model="form.logradouro"
              :error-messages="errors"
              solo
              dense
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="6" sm="3" md="2" class="pt-0 pb-0">
          <e-label>Número</e-label>
          <v-text-field
            id="input-numero"
            v-model="form.numero"
            :error-messages="errors"
            solo
            dense
            v-mask="'#######################'"
          />
        </v-col>
        <v-col cols="6" sm="3" md="2" class="pt-0 pb-0">
          <e-label>Telefone</e-label>
          <v-text-field
            id="input-telefone"
            v-mask="'(##) ####-####'"
            v-model="form.telefone"
            solo
            dense
          />
        </v-col>
        <v-col cols="6" sm="3" md="2" class="pt-0 pb-0">
          <e-label>Celular 1</e-label>
          <v-text-field
            id="input-celular1"
            v-mask="'(##)# ####-####'"
            v-model="form.celular"
            solo
            dense
          />
        </v-col>
        <v-col cols="6" sm="3" md="2" class="pt-0 pb-0">
          <e-label>Celular 2</e-label>
          <v-text-field
            id="input-celular2"
            v-mask="'(##)# ####-####'"
            v-model="form.celular2"
            solo
            dense
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pt-0 pb-0">
          <e-label>Contexto</e-label>
          <v-text-field id="input-contexto" v-model="form.contexto" solo dense />
        </v-col>
        <v-col cols="12" class="mt-4">
          <v-btn
            id="btn-enviar-dados"
            color="primary"
            :disabled="criandoFranquia"
            :loading="criandoFranquia"
            type="submit"
            block
            large
          >
            Enviar Dados
          </v-btn>
        </v-col>
      </v-row>
    </form>
  </main-template>
</template>

<script>
export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    franquia(franquiaValue) {
      if (!franquiaValue) {
        this.form = {};
        return;
      }
      this.form = {
        ...franquiaValue,
      };
    },
    form: {
      async handler(formValue) {
        try {
          const cepValue = this.$services.cepService.getCepInteiro(formValue.cep);
          if (cepValue) {
            const localizacao = await this.$services.cepService.buscarDadosDoCep(cepValue);
            if (localizacao.cidade && localizacao.estado) {
              this.form.cidade = localizacao.cidade;
              this.form.estado = localizacao.estado;
            }
            if (localizacao.bairro && localizacao.rua) {
              this.form.bairro = localizacao.bairro;
              this.form.logradouro = localizacao.rua;
            }
          }
        } catch (error) {
          this.$handleError("Erro ao buscar informações do CEP");
        }
      },
      deep: true,
    },
  },
  async mounted() {
    const { franquia_id } = this.$route.params;
    this.form = await this.$services.franquiasService.getFranquia(franquia_id);
  },
  data() {
    return {
      criandoFranquia: false,
      form: {},
    };
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      this.criandoFranquia = true;
      try {
        if (this.editing) {
          await this.$services.franquiasService.atualizarFranquia(this.form);
        } else {
          await this.$services.franquiasService.criarFranquia(this.form);
        }
        this.$toast.success("Franquia Atualizada com sucesso");
        this.$router.push({ name: "franquias" });
      } catch (error) {
        this.$handleError(error);
      }
      this.criandoFranquia = false;
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-text-field {
    margin-bottom: 8px;
  }

  h1,
  h2 {
    font-size: 1.2rem;
  }
}

.pt-0.pb-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

e-label {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
}
</style>
